"use client"

import { useFlowRoutes } from "@/platform/experiments/FlowRoutesProvider"
import { useLastCheckoutProductRef } from "@/platform/shopper/carts.client"
import { useBag } from "@/platform/shopper/use-cart"

export const useBagCount = (override?: number): number => {
  const flowRoutes = useFlowRoutes()
  const ref = useLastCheckoutProductRef()
  const { cart } = useBag(flowRoutes)
  if (override !== undefined) return override
  if (!flowRoutes) return ref ? 1 : 0
  return cart?.items.reduce((total, item) => total + item.quantity, 0) ?? 0
}
